import React from 'react';
import * as S from './styles';
import InfoFilled from './InfoFilled.svg';
import AwayFilled from './AwayFilled.svg';
import SuccessFilled from './SuccessFilled.svg';

type Mode = 'info' | 'success' | 'away';

const modeIcons: Record<Mode, string> = {
    info: InfoFilled,
    success: SuccessFilled,
    away: AwayFilled,
};

interface DisclaimerBoxProps {
    mode: Mode;
    title?: string;
    children: React.ReactNode;
}

export const DisclaimerBox = ({ mode, title, children }: DisclaimerBoxProps) => (
    <S.Box $mode={mode}>
        <img src={modeIcons[mode]} alt={mode} />
        <S.Texts>
            {title && <S.Title $mode={mode}>{title}</S.Title>}
            <S.Content>{children}</S.Content>
        </S.Texts>
    </S.Box>
);
